// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3_2bt","errors":"Errors_errors__1v3mH"};